import type { Location, Screen } from '@ghostscreen/contracts';

/** Schedule windows use the screen location's IANA timezone (ADR 0004). */
export function timezoneForScreen(
  screen: Screen | undefined,
  locations: Location[],
): string | null {
  if (!screen) return null;
  return locations.find((location) => location.id === screen.locationId)?.timezone ?? null;
}

export function locationNameForScreen(
  screen: Screen | undefined,
  locations: Location[],
): string | null {
  if (!screen) return null;
  return locations.find((location) => location.id === screen.locationId)?.name ?? null;
}
